let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("lCNhg")).then(() => parcelRequire('45SMe'));